export const menuItems = [
    {
        label: 'Home',
        path: '/',
        icon: '',
    },
    {
        label: 'Who We Are',
        path: '/#who-we-are',
        icon: '',
    },
    {
        label: 'What We Do',
        path: '/#what-we-do',
        icon: '',
    },
    {
        label: 'Our Approach',
        path: '/our-approach',
        icon: '',
    },
    {
        label: 'Work with Us',
        path: '/work-with-us',
        icon: '',
    },
    {
        label: 'Blog',
        path: '/blog',
        icon: '',
    },
    {
        label: 'Contact',
        path: '/#contact',
        icon: '',
    }
]
